"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlResourceTypeEnum = void 0;
var GlResourceTypeEnum;
(function (GlResourceTypeEnum) {
    GlResourceTypeEnum["EVENT"] = "event";
    GlResourceTypeEnum["LEAGUE"] = "league";
    GlResourceTypeEnum["MEMBERSHIP"] = "membership";
    GlResourceTypeEnum["PROGRAM"] = "program";
    GlResourceTypeEnum["PROGRAM_SEASON"] = "program_season";
    GlResourceTypeEnum["PRODUCT"] = "product";
    GlResourceTypeEnum["FEE"] = "fee";
    GlResourceTypeEnum["DISCOUNT"] = "discount";
    GlResourceTypeEnum["ACTIVITY"] = "activity";
    GlResourceTypeEnum["PROGRAM_TYPE"] = "program_type";
    GlResourceTypeEnum["TAX"] = "tax";
    GlResourceTypeEnum["SEGMENT"] = "segment";
    GlResourceTypeEnum["SPACE"] = "space";
    GlResourceTypeEnum["FACILITY"] = "facility";
})(GlResourceTypeEnum = exports.GlResourceTypeEnum || (exports.GlResourceTypeEnum = {}));
//# sourceMappingURL=gl-code.enum.js.map